import { NavigateFunction } from "react-router-dom";
import EnumRoute from "./RoutesEnums";

export default class UserRoutesService {
  constructor(private navigtion: NavigateFunction) {
    this.redirectByUrlParams();
  }

  public redirectByUrlParams() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const value = urlParams.get("r");
      if(value == null) return;
      const e = EnumRoute.getEnumByValue("/"+value);

      if (e == undefined) return;
      this.navigtion(e.valueOf());
    } catch (e) {}
  }
}
